<template>
  <p
    key="former-error"
    :class="classes"
  >
    <slot>
      <b>Oops!</b>

      Algo deu errado. Por favor, verifique os campos preenchidos e tente novamente.
    </slot>

    <span
      v-if="message"
      class="former-error-message"
    >
      {{ message }}
    </span>
  </p>
</template>

<script>
  export default {
    name: 'FormerError',
    props: {
      left: {
        type: Boolean,
        default: false,
      },
      details: {
        type: String,
        default: '',
      },
    },
    computed: {
      classes() {
        const classes = ['former-error'];

        if (this.left) {
          classes.push('former-error-left');
        }

        return classes;
      },
      message() {
        const {
          details,
        } = this;

        if (!details) {
          return null;
        }

        return details.match(/\.$/) ? details : `${details}.`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .former-error {
    background-color: $red;
    color: $white;
    padding: $gutter;
    text-align: center;

    @media all and (min-width: $breakpoint-desktop) {
      padding: $gutter $gutter-big;
    }
  }

  .former-error-left {
    text-align: left;
  }

  .former-error-message {
    display: block;
  }
</style>
